import type { FC } from 'react';
import React from 'react';
import { Flex, DecorationLine, Box } from '@edreamsodigeo/prisma-design-system';

import CarrierChangeMapItinerary from './CarrierChangeMapItinerary';
import ConnectionChangeTypeMapItinerary from './ConnectionChangeTypeMapItinerary';
import ConnectionInsuranceMapItinerary from './ConnectionInsuranceMapItinerary';
import CovidRestrictionMapItinerary from './CovidRestrictionMapItinerary';
import StopDurationMapItinerary from './StopDurationMapItinerary';
import LeftContentWrapper from './LeftContentWrapper';
import type { Stopover } from '@/components/FlightSummary/Segment/resolver';

interface StopOverMapItineraryProps {
  vinRestriction: Stopover['vinRestriction'];
  duration: Stopover['duration'];
  locationChangeType: Stopover['locationChangeType'];
  transportType: Stopover['transportType'];
  carrierChange: Stopover['carrierChange'];
  insuranceOffer: Stopover['insuranceOffer'];
}

interface ConnectionChangeWrapperProps {
  transportType: Stopover['transportType'];
  carrierChange: Stopover['carrierChange'];
  locationChangeType: Stopover['locationChangeType'];
  insuranceOffer: Stopover['insuranceOffer'];
  vinRestriction: Stopover['vinRestriction'];
}

const ConnectionChangeWrapper: FC<ConnectionChangeWrapperProps> = ({
  transportType,
  carrierChange,
  locationChangeType,
  insuranceOffer,
  vinRestriction,
}) => {
  return (
    <>
      {carrierChange && (
        <CarrierChangeMapItinerary transportType={transportType} />
      )}
      <ConnectionChangeTypeMapItinerary
        locationChangeType={locationChangeType}
      />
      <ConnectionInsuranceMapItinerary {...insuranceOffer} />
      {vinRestriction.enabled && (
        <CovidRestrictionMapItinerary country={vinRestriction.country} />
      )}
    </>
  );
};

const StopOverMapItinerary: FC<StopOverMapItineraryProps> = ({
  vinRestriction,
  duration,
  locationChangeType,
  transportType,
  carrierChange,
  insuranceOffer,
}) => {
  return (
    <>
      <Flex>
        <LeftContentWrapper />
        <DecorationLine decorationType="none" lineType="dashed" alignBottom />
        <Flex flexDirection="column">
          <StopDurationMapItinerary duration={duration} />
          <Box mb="big">
            <ConnectionChangeWrapper
              transportType={transportType}
              carrierChange={carrierChange}
              locationChangeType={locationChangeType || 'none'}
              insuranceOffer={insuranceOffer}
              vinRestriction={vinRestriction}
            />
          </Box>
        </Flex>
      </Flex>
      <Flex>
        <LeftContentWrapper />
        <DecorationLine decorationType="none" lineType="dashed" />
      </Flex>
    </>
  );
};

export default StopOverMapItinerary;
